import React from 'react';
import { connect } from 'react-redux';

import { setChoiceType } from '../../../../../../_actions/question-library.action'

const ChoiceType = ({ question, dispatch }) => {

  const itemControl = question.extension.find((extension) => {
    return extension.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl"
  });

  return <div className="form-group">
    <label><strong>Select One or Many</strong></label>

    <div className="form-check">
      <input
        onChange={(e) => { dispatch(setChoiceType(e.target.value)) }}
        id={`choice-${question.linkId}_check-box`}
        name={`choice-${question.linkId}`}
        checked={itemControl.valueCodeableConcept.coding[0].code === 'check-box'}
        className="form-check-input"
        type="radio"
        value="check-box" />
      <label
        htmlFor={`choice-${question.linkId}_check-box`}
        className="form-check-label">Many</label>
    </div>

    <div className="form-check">
      <input
        onChange={(e) => { dispatch(setChoiceType(e.target.value)) }}
        id={`choice-${question.linkId}_radio-button`}
        name={`choice-${question.linkId}`}
        checked={itemControl.valueCodeableConcept.coding[0].code === 'radio-button'}
        className="form-check-input"
        type="radio"
        value="radio-button" />
      <label
        htmlFor={`choice-${question.linkId}_radio-button`}
        className="form-check-label">One</label>
    </div>
  </div>
}

export default connect()(ChoiceType);